export enum THEME_MODES {
    DARK = 'dark',
    LIGHT = 'light',
}
